'user strict';

import { createSelector } from 'reselect';

import { getPageUsername, getPageJobId, getUrlParams } from '../app/selectors';
import { getPageJob } from '../orders/selectors';

export const getProps = (_, props) => props;
export const getAttemptsMap = ({ attempts }) => attempts.byId;
export const getAttemptIdsByUserDate = ({ attempts }) => attempts.idsByUserDate;

export const getPropAttempt = createSelector(
	[ getProps, getAttemptsMap ],
	({ attemptId }, attempts) => attempts[ attemptId ]
);

const getJobId = (state, props) => {
	return props.match.params.jobId;
};

const getDate = createSelector(
	[ getUrlParams ],
	urlParams => urlParams.date
);

export const getServeAttempt = createSelector(
	[ getPageJob, getAttemptsMap ],
	(job, attemptsMap) => Object.entries(attemptsMap).reduce(
		(serve, [ _id, attempt ]) => {
			if (serve) {
				return serve;
			}
			if (attempt.jobId === job._id && attempt.type === 'SERVE') {
				return attempt;
			}
		},
		null
	)
);

export const getPostAttempt = createSelector(
	[ getPageJob, getAttemptsMap ],
	(job, attemptsMap) => Object.entries(attemptsMap).reduce(
		(serve, [ _id, attempt ]) => {
			if (serve) {
				return serve;
			}
			if (attempt.jobId === job._id && attempt.type === 'POST') {
				return attempt;
			}
		},
		null
	)
);

export const getBadAddressAttempt = createSelector(
	[ getPageJob, getAttemptsMap ],
	(job, attemptsMap) => Object.entries(attemptsMap).reduce(
		(badAddress, [ _id, attempt ]) => {
			if (badAddress) {
				return badAddress;
			}
			if (attempt.jobId === job._id && attempt.type === 'BAD_ADDRESS') {
				return attempt;
			}
		},
		null
	)
);

export const getPickupAttempt = createSelector(
	[ getPageJob, getAttemptsMap ],
	(job, attemptsMap) => Object.entries(attemptsMap).reduce(
		(pickup, [ _id, attempt ]) => {
			if (pickup) {
				return pickup;
			}
			if (attempt.jobId === job._id && attempt.type === 'PICKUP') {
				return attempt;
			}
		},
		null
	)
);

export const getDeliveryAttempt = createSelector(
	[ getPageJob, getAttemptsMap ],
	(job, attemptsMap) => Object.entries(attemptsMap).reduce(
		(pickup, [ _id, attempt ]) => {
			if (pickup) {
				return pickup;
			}
			if (attempt.jobId === job._id && attempt.type === 'DELIVERY') {
				return attempt;
			}
		},
		null
	)
);

export const getJobAttempts = createSelector(
	[ getProps, getAttemptsMap ],
	({ job, location }, attemptsMap) => Object.entries(attemptsMap).reduce(
		(attempts, [ _id, attempt ]) => {
			if (attempt.jobId === job._id && attempt.locationId === location._id) {
				return [ ...attempts, attempt ];
			}
			return attempts;
		},
		[]
	)
);

export const getPropDailyAttempts = createSelector(
	[ getProps, getAttemptIdsByUserDate, getAttemptsMap ],
	({ username, date }, idsByUserDate, map) => {

		if (!(username in idsByUserDate) || !(date in idsByUserDate[ username ])) {
			return [];
		}

		const ids = idsByUserDate[ username ][ date ];
		const attempts = [];

		ids.forEach(id => {
			attempts.push(map[ id ]);
		})
		
		return attempts;
	}
);

export const getDailyAttempts = createSelector(
	[ getPageUsername, getDate, getAttemptIdsByUserDate, getAttemptsMap ],
	(username, date, idsByUserDate, map) => {

		if (!(username in idsByUserDate) || !(date in idsByUserDate[ username ])) {
			return [];
		}

		const ids = idsByUserDate[ username ][ date ];
		const attempts = [];

		ids.forEach(id => {
			attempts.push(map[ id ]);
		})
		
		return attempts;
	}
);

export const isDayAttempted = createSelector(
	[ getDailyAttempts, getPageJob ],
	(attempts, job) => attempts.find(a => a.jobId === job._id)
);
